/*! Magnific Popup - v1.1.0 - 2016-02-20
 * http://dimsemenov.com/plugins/magnific-popup/
 * Copyright (c) 2016 Dmitry Semenov; */ (function (factory) {
    typeof define == "function" && define.amd
        ? define(["jquery"], factory)
        : factory(typeof exports == "object" ? require("jquery") : window.jQuery || window.Zepto);
})(function ($2) {
    var CLOSE_EVENT = "Close",
        BEFORE_CLOSE_EVENT = "BeforeClose",
        AFTER_CLOSE_EVENT = "AfterClose",
        BEFORE_APPEND_EVENT = "BeforeAppend",
        MARKUP_PARSE_EVENT = "MarkupParse",
        OPEN_EVENT = "Open",
        CHANGE_EVENT = "Change",
        NS = "mfp",
        EVENT_NS = "." + NS,
        READY_CLASS = "mfp-ready",
        REMOVING_CLASS = "mfp-removing",
        PREVENT_CLOSE_CLASS = "mfp-prevent-close",
        mfp,
        MagnificPopup = function () {},
        _isJQ = !!window.jQuery,
        _prevStatus,
        _window = $2(window),
        _document,
        _prevContentType,
        _wrapClasses,
        _currPopupType,
        _mfpOn = function (name, f) {
            mfp.ev.on(NS + name + EVENT_NS, f);
        },
        _getEl = function (className, appendTo, html, raw) {
            var el = document.createElement("div");
            return (
                (el.className = "mfp-" + className),
                html && (el.innerHTML = html),
                raw ? appendTo && appendTo.appendChild(el) : ((el = $2(el)), appendTo && el.appendTo(appendTo)),
                el
            );
        },
        _mfpTrigger = function (e, data) {
            mfp.ev.triggerHandler(NS + e, data),
                mfp.st.callbacks &&
                    ((e = e.charAt(0).toLowerCase() + e.slice(1)),
                    mfp.st.callbacks[e] && mfp.st.callbacks[e].apply(mfp, $2.isArray(data) ? data : [data]));
        },
        _getCloseBtn = function (type) {
            return (
                (type !== _currPopupType || !mfp.currTemplate.closeBtn) &&
                    ((mfp.currTemplate.closeBtn = $2(mfp.st.closeMarkup.replace("%title%", mfp.st.tClose))),
                    (_currPopupType = type)),
                mfp.currTemplate.closeBtn
            );
        },
        _checkInstance = function () {
            $2.magnificPopup.instance || ((mfp = new MagnificPopup()), mfp.init(), ($2.magnificPopup.instance = mfp));
        },
        supportsTransitions = function () {
            var s = document.createElement("p").style,
                v = ["ms", "O", "Moz", "Webkit"];
            if (s.transition !== void 0) return !0;
            for (; v.length; ) if (v.pop() + "Transition" in s) return !0;
            return !1;
        };
    (MagnificPopup.prototype = {
        constructor: MagnificPopup,
        init: function () {
            var appVersion = navigator.appVersion;
            (mfp.isLowIE = mfp.isIE8 = document.all && !document.addEventListener),
                (mfp.isAndroid = /android/gi.test(appVersion)),
                (mfp.isIOS = /iphone|ipad|ipod/gi.test(appVersion)),
                (mfp.supportsTransition = supportsTransitions()),
                (mfp.probablyMobile =
                    mfp.isAndroid ||
                    mfp.isIOS ||
                    /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
                        navigator.userAgent
                    )),
                (_document = $2(document)),
                (mfp.popupsCache = {});
        },
        open: function (data) {
            var i;
            if (data.isObj === !1) {
                (mfp.items = data.items.toArray()), (mfp.index = 0);
                var items = data.items,
                    item;
                for (i = 0; i < items.length; i++)
                    if (((item = items[i]), item.parsed && (item = item.el[0]), item === data.el[0])) {
                        mfp.index = i;
                        break;
                    }
            } else (mfp.items = $2.isArray(data.items) ? data.items : [data.items]), (mfp.index = data.index || 0);
            if (mfp.isOpen) {
                mfp.updateItemHTML();
                return;
            }
            (mfp.types = []),
                (_wrapClasses = ""),
                data.mainEl && data.mainEl.length ? (mfp.ev = data.mainEl.eq(0)) : (mfp.ev = _document),
                data.key
                    ? (mfp.popupsCache[data.key] || (mfp.popupsCache[data.key] = {}),
                      (mfp.currTemplate = mfp.popupsCache[data.key]))
                    : (mfp.currTemplate = {}),
                (mfp.st = $2.extend(!0, {}, $2.magnificPopup.defaults, data)),
                (mfp.fixedContentPos =
                    mfp.st.fixedContentPos === "auto" ? !mfp.probablyMobile : mfp.st.fixedContentPos),
                mfp.st.modal &&
                    ((mfp.st.closeOnContentClick = !1),
                    (mfp.st.closeOnBgClick = !1),
                    (mfp.st.showCloseBtn = !1),
                    (mfp.st.enableEscapeKey = !1)),
                mfp.bgOverlay ||
                    ((mfp.bgOverlay = _getEl("bg").on("click" + EVENT_NS, function () {
                        mfp.close();
                    })),
                    (mfp.wrap = _getEl("wrap")
                        .attr("tabindex", -1)
                        .on("click" + EVENT_NS, function (e) {
                            mfp._checkIfClose(e.target) && mfp.close();
                        })),
                    (mfp.container = _getEl("container", mfp.wrap))),
                (mfp.contentContainer = _getEl("content")),
                mfp.st.preloader && (mfp.preloader = _getEl("preloader", mfp.container, mfp.st.tLoading));
            var modules = $2.magnificPopup.modules;
            for (i = 0; i < modules.length; i++) {
                var n = modules[i];
                (n = n.charAt(0).toUpperCase() + n.slice(1)), mfp["init" + n].call(mfp);
            }
            _mfpTrigger("BeforeOpen"),
                mfp.st.showCloseBtn &&
                    (mfp.st.closeBtnInside
                        ? (_mfpOn(MARKUP_PARSE_EVENT, function (e, template, values, item2) {
                              values.close_replaceWith = _getCloseBtn(item2.type);
                          }),
                          (_wrapClasses += " mfp-close-btn-in"))
                        : mfp.wrap.append(_getCloseBtn())),
                mfp.st.alignTop && (_wrapClasses += " mfp-align-top"),
                mfp.fixedContentPos
                    ? mfp.wrap.css({ overflow: mfp.st.overflowY, overflowX: "hidden", overflowY: mfp.st.overflowY })
                    : mfp.wrap.css({ top: _window.scrollTop(), position: "absolute" }),
                (mfp.st.fixedBgPos === !1 || (mfp.st.fixedBgPos === "auto" && !mfp.fixedContentPos)) &&
                    mfp.bgOverlay.css({ height: _document.height(), position: "absolute" }),
                mfp.st.enableEscapeKey &&
                    _document.on("keyup" + EVENT_NS, function (e) {
                        e.keyCode === 27 && mfp.close();
                    }),
                _window.on("resize" + EVENT_NS, function () {
                    mfp.updateSize();
                }),
                mfp.st.closeOnContentClick || (_wrapClasses += " mfp-auto-cursor"),
                _wrapClasses && mfp.wrap.addClass(_wrapClasses);
            var windowHeight = (mfp.wH = _window.height()),
                windowStyles = {};
            if (mfp.fixedContentPos && mfp._hasScrollBar(windowHeight)) {
                var s = mfp._getScrollbarSize();
                s && (windowStyles.marginRight = s);
            }
            mfp.fixedContentPos &&
                (mfp.isIE7 ? $2("body, html").css("overflow", "hidden") : (windowStyles.overflow = "hidden"));
            var classesToadd = mfp.st.mainClass;
            return (
                mfp.isIE7 && (classesToadd += " mfp-ie7"),
                classesToadd && mfp._addClassToMFP(classesToadd),
                mfp.updateItemHTML(),
                _mfpTrigger("BuildControls"),
                $2("html").css(windowStyles),
                mfp.bgOverlay.add(mfp.wrap).prependTo(mfp.st.prependTo || $2(document.body)),
                (mfp._lastFocusedEl = document.activeElement),
                setTimeout(function () {
                    mfp.content
                        ? (mfp._addClassToMFP(READY_CLASS), mfp._setFocus())
                        : mfp.bgOverlay.addClass(READY_CLASS),
                        _document.on("focusin" + EVENT_NS, mfp._onFocusIn);
                }, 16),
                (mfp.isOpen = !0),
                mfp.updateSize(windowHeight),
                _mfpTrigger(OPEN_EVENT),
                data
            );
        },
        close: function () {
            mfp.isOpen &&
                (_mfpTrigger(BEFORE_CLOSE_EVENT),
                (mfp.isOpen = !1),
                mfp.st.removalDelay && !mfp.isLowIE && mfp.supportsTransition
                    ? (mfp._addClassToMFP(REMOVING_CLASS),
                      setTimeout(function () {
                          mfp._close();
                      }, mfp.st.removalDelay))
                    : mfp._close());
        },
        _close: function () {
            _mfpTrigger(CLOSE_EVENT);
            var classesToRemove = REMOVING_CLASS + " " + READY_CLASS + " ";
            if (
                (mfp.bgOverlay.detach(),
                mfp.wrap.detach(),
                mfp.container.empty(),
                mfp.st.mainClass && (classesToRemove += mfp.st.mainClass + " "),
                mfp._removeClassFromMFP(classesToRemove),
                mfp.fixedContentPos)
            ) {
                var windowStyles = { marginRight: "" };
                mfp.isIE7 ? $2("body, html").css("overflow", "") : (windowStyles.overflow = ""),
                    $2("html").css(windowStyles);
            }
            _document.off("keyup" + EVENT_NS + " focusin" + EVENT_NS),
                mfp.ev.off(EVENT_NS),
                mfp.wrap.attr("class", "mfp-wrap").removeAttr("style"),
                mfp.bgOverlay.attr("class", "mfp-bg"),
                mfp.container.attr("class", "mfp-container"),
                mfp.st.showCloseBtn &&
                    (!mfp.st.closeBtnInside || mfp.currTemplate[mfp.currItem.type] === !0) &&
                    mfp.currTemplate.closeBtn &&
                    mfp.currTemplate.closeBtn.detach(),
                mfp.st.autoFocusLast && mfp._lastFocusedEl && $2(mfp._lastFocusedEl).focus(),
                (mfp.currItem = null),
                (mfp.content = null),
                (mfp.currTemplate = null),
                (mfp.prevHeight = 0),
                _mfpTrigger(AFTER_CLOSE_EVENT);
        },
        updateSize: function (winHeight) {
            if (mfp.isIOS) {
                var zoomLevel = document.documentElement.clientWidth / window.innerWidth,
                    height = window.innerHeight * zoomLevel;
                mfp.wrap.css("height", height), (mfp.wH = height);
            } else mfp.wH = winHeight || _window.height();
            mfp.fixedContentPos || mfp.wrap.css("height", mfp.wH), _mfpTrigger("Resize");
        },
        updateItemHTML: function () {
            var item = mfp.items[mfp.index];
            mfp.contentContainer.detach(),
                mfp.content && mfp.content.detach(),
                item.parsed || (item = mfp.parseEl(mfp.index));
            var type = item.type;
            if (
                (_mfpTrigger("BeforeChange", [mfp.currItem ? mfp.currItem.type : "", type]),
                (mfp.currItem = item),
                !mfp.currTemplate[type])
            ) {
                var markup = mfp.st[type] ? mfp.st[type].markup : !1;
                _mfpTrigger("FirstMarkupParse", markup),
                    markup ? (mfp.currTemplate[type] = $2(markup)) : (mfp.currTemplate[type] = !0);
            }
            _prevContentType &&
                _prevContentType !== item.type &&
                mfp.container.removeClass("mfp-" + _prevContentType + "-holder");
            var newContent = mfp["get" + type.charAt(0).toUpperCase() + type.slice(1)](item, mfp.currTemplate[type]);
            mfp.appendContent(newContent, type),
                (item.preloaded = !0),
                _mfpTrigger(CHANGE_EVENT, item),
                (_prevContentType = item.type),
                mfp.container.prepend(mfp.contentContainer),
                _mfpTrigger("AfterChange");
        },
        appendContent: function (newContent, type) {
            (mfp.content = newContent),
                newContent
                    ? mfp.st.showCloseBtn && mfp.st.closeBtnInside && mfp.currTemplate[type] === !0
                        ? mfp.content.find(".mfp-close").length || mfp.content.append(_getCloseBtn())
                        : (mfp.content = newContent)
                    : (mfp.content = ""),
                _mfpTrigger(BEFORE_APPEND_EVENT),
                mfp.container.addClass("mfp-" + type + "-holder"),
                mfp.contentContainer.append(mfp.content);
        },
        parseEl: function (index) {
            var item = mfp.items[index],
                type;
            if (
                (item.tagName
                    ? (item = { el: $2(item) })
                    : ((type = item.type), (item = { data: item, src: item.src })),
                item.el)
            ) {
                for (var types = mfp.types, i = 0; i < types.length; i++)
                    if (item.el.hasClass("mfp-" + types[i])) {
                        type = types[i];
                        break;
                    }
                (item.src = item.el.attr("data-mfp-src")), item.src || (item.src = item.el.attr("href"));
            }
            return (
                (item.type = type || mfp.st.type || "inline"),
                (item.index = index),
                (item.parsed = !0),
                (mfp.items[index] = item),
                _mfpTrigger("ElementParse", item),
                mfp.items[index]
            );
        },
        addGroup: function (el, options) {
            var eHandler = function (e) {
                (e.mfpEl = this), mfp._openClick(e, el, options);
            };
            options || (options = {});
            var eName = "click.magnificPopup";
            (options.mainEl = el),
                options.items
                    ? ((options.isObj = !0), el.off(eName).on(eName, eHandler))
                    : ((options.isObj = !1),
                      options.delegate
                          ? el.off(eName).on(eName, options.delegate, eHandler)
                          : ((options.items = el), el.off(eName).on(eName, eHandler)));
        },
        _openClick: function (e, el, options) {
            var midClick = options.midClick !== void 0 ? options.midClick : $2.magnificPopup.defaults.midClick;
            if (!(!midClick && (e.which === 2 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey))) {
                var disableOn = options.disableOn !== void 0 ? options.disableOn : $2.magnificPopup.defaults.disableOn;
                if (disableOn) {
                    if ($2.isFunction(disableOn)) {
                        if (!disableOn.call(mfp)) return !0;
                    } else if (_window.width() < disableOn) return !0;
                }
                e.type && (e.preventDefault(), mfp.isOpen && e.stopPropagation()),
                    (options.el = $2(e.mfpEl)),
                    options.delegate && (options.items = el.find(options.delegate)),
                    mfp.open(options);
            }
        },
        updateStatus: function (status, text) {
            if (mfp.preloader) {
                _prevStatus !== status && mfp.container.removeClass("mfp-s-" + _prevStatus),
                    !text && status === "loading" && (text = mfp.st.tLoading);
                var data = { status, text };
                _mfpTrigger("UpdateStatus", data),
                    (status = data.status),
                    (text = data.text),
                    mfp.preloader.html(text),
                    mfp.preloader.find("a").on("click", function (e) {
                        e.stopImmediatePropagation();
                    }),
                    mfp.container.addClass("mfp-s-" + status),
                    (_prevStatus = status);
            }
        },
        _checkIfClose: function (target) {
            if (!$2(target).hasClass(PREVENT_CLOSE_CLASS)) {
                var closeOnContent = mfp.st.closeOnContentClick,
                    closeOnBg = mfp.st.closeOnBgClick;
                if (closeOnContent && closeOnBg) return !0;
                if (!mfp.content || $2(target).hasClass("mfp-close") || (mfp.preloader && target === mfp.preloader[0]))
                    return !0;
                if (target !== mfp.content[0] && !$2.contains(mfp.content[0], target)) {
                    if (closeOnBg && $2.contains(document, target)) return !0;
                } else if (closeOnContent) return !0;
                return !1;
            }
        },
        _addClassToMFP: function (cName) {
            mfp.bgOverlay.addClass(cName), mfp.wrap.addClass(cName);
        },
        _removeClassFromMFP: function (cName) {
            this.bgOverlay.removeClass(cName), mfp.wrap.removeClass(cName);
        },
        _hasScrollBar: function (winHeight) {
            return (mfp.isIE7 ? _document.height() : document.body.scrollHeight) > (winHeight || _window.height());
        },
        _setFocus: function () {
            (mfp.st.focus ? mfp.content.find(mfp.st.focus).eq(0) : mfp.wrap).focus();
        },
        _onFocusIn: function (e) {
            if (e.target !== mfp.wrap[0] && !$2.contains(mfp.wrap[0], e.target)) return mfp._setFocus(), !1;
        },
        _parseMarkup: function (template, values, item) {
            var arr;
            item.data && (values = $2.extend(item.data, values)),
                _mfpTrigger(MARKUP_PARSE_EVENT, [template, values, item]),
                $2.each(values, function (key, value) {
                    if (value === void 0 || value === !1) return !0;
                    if (((arr = key.split("_")), arr.length > 1)) {
                        var el = template.find(EVENT_NS + "-" + arr[0]);
                        if (el.length > 0) {
                            var attr = arr[1];
                            attr === "replaceWith"
                                ? el[0] !== value[0] && el.replaceWith(value)
                                : attr === "img"
                                  ? el.is("img")
                                      ? el.attr("src", value)
                                      : el.replaceWith($2("<img>").attr("src", value).attr("class", el.attr("class")))
                                  : el.attr(arr[1], value);
                        }
                    } else template.find(EVENT_NS + "-" + key).html(value);
                });
        },
        _getScrollbarSize: function () {
            if (mfp.scrollbarSize === void 0) {
                var scrollDiv = document.createElement("div");
                (scrollDiv.style.cssText =
                    "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"),
                    document.body.appendChild(scrollDiv),
                    (mfp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth),
                    document.body.removeChild(scrollDiv);
            }
            return mfp.scrollbarSize;
        },
    }),
        ($2.magnificPopup = {
            instance: null,
            proto: MagnificPopup.prototype,
            modules: [],
            open: function (options, index) {
                return (
                    _checkInstance(),
                    options ? (options = $2.extend(!0, {}, options)) : (options = {}),
                    (options.isObj = !0),
                    (options.index = index || 0),
                    this.instance.open(options)
                );
            },
            close: function () {
                return $2.magnificPopup.instance && $2.magnificPopup.instance.close();
            },
            registerModule: function (name, module) {
                module.options && ($2.magnificPopup.defaults[name] = module.options),
                    $2.extend(this.proto, module.proto),
                    this.modules.push(name);
            },
            defaults: {
                disableOn: 0,
                key: null,
                midClick: !1,
                mainClass: "",
                preloader: !0,
                focus: "",
                closeOnContentClick: !1,
                closeOnBgClick: !0,
                closeBtnInside: !0,
                showCloseBtn: !0,
                enableEscapeKey: !0,
                modal: !1,
                alignTop: !1,
                removalDelay: 0,
                prependTo: null,
                fixedContentPos: "auto",
                fixedBgPos: "auto",
                overflowY: "auto",
                closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
                tClose: "Close (Esc)",
                tLoading: "Loading...",
                autoFocusLast: !0,
            },
        }),
        ($2.fn.magnificPopup = function (options) {
            _checkInstance();
            var jqEl = $2(this);
            if (typeof options == "string")
                if (options === "open") {
                    var items,
                        itemOpts = _isJQ ? jqEl.data("magnificPopup") : jqEl[0].magnificPopup,
                        index = parseInt(arguments[1], 10) || 0;
                    itemOpts.items
                        ? (items = itemOpts.items[index])
                        : ((items = jqEl),
                          itemOpts.delegate && (items = items.find(itemOpts.delegate)),
                          (items = items.eq(index))),
                        mfp._openClick({ mfpEl: items }, jqEl, itemOpts);
                } else mfp.isOpen && mfp[options].apply(mfp, Array.prototype.slice.call(arguments, 1));
            else
                (options = $2.extend(!0, {}, options)),
                    _isJQ ? jqEl.data("magnificPopup", options) : (jqEl[0].magnificPopup = options),
                    mfp.addGroup(jqEl, options);
            return jqEl;
        });
    var INLINE_NS = "inline",
        _hiddenClass,
        _inlinePlaceholder,
        _lastInlineElement,
        _putInlineElementsBack = function () {
            _lastInlineElement &&
                (_inlinePlaceholder.after(_lastInlineElement.addClass(_hiddenClass)).detach(),
                (_lastInlineElement = null));
        };
    $2.magnificPopup.registerModule(INLINE_NS, {
        options: { hiddenClass: "hide", markup: "", tNotFound: "Content not found" },
        proto: {
            initInline: function () {
                mfp.types.push(INLINE_NS),
                    _mfpOn(CLOSE_EVENT + "." + INLINE_NS, function () {
                        _putInlineElementsBack();
                    });
            },
            getInline: function (item, template) {
                if ((_putInlineElementsBack(), item.src)) {
                    var inlineSt = mfp.st.inline,
                        el = $2(item.src);
                    if (el.length) {
                        var parent = el[0].parentNode;
                        parent &&
                            parent.tagName &&
                            (_inlinePlaceholder ||
                                ((_hiddenClass = inlineSt.hiddenClass),
                                (_inlinePlaceholder = _getEl(_hiddenClass)),
                                (_hiddenClass = "mfp-" + _hiddenClass)),
                            (_lastInlineElement = el.after(_inlinePlaceholder).detach().removeClass(_hiddenClass))),
                            mfp.updateStatus("ready");
                    } else mfp.updateStatus("error", inlineSt.tNotFound), (el = $2("<div>"));
                    return (item.inlineElement = el), el;
                }
                return mfp.updateStatus("ready"), mfp._parseMarkup(template, {}, item), template;
            },
        },
    });
    var AJAX_NS = "ajax",
        _ajaxCur,
        _removeAjaxCursor = function () {
            _ajaxCur && $2(document.body).removeClass(_ajaxCur);
        },
        _destroyAjaxRequest = function () {
            _removeAjaxCursor(), mfp.req && mfp.req.abort();
        };
    $2.magnificPopup.registerModule(AJAX_NS, {
        options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.',
        },
        proto: {
            initAjax: function () {
                mfp.types.push(AJAX_NS),
                    (_ajaxCur = mfp.st.ajax.cursor),
                    _mfpOn(CLOSE_EVENT + "." + AJAX_NS, _destroyAjaxRequest),
                    _mfpOn("BeforeChange." + AJAX_NS, _destroyAjaxRequest);
            },
            getAjax: function (item) {
                _ajaxCur && $2(document.body).addClass(_ajaxCur), mfp.updateStatus("loading");
                var opts = $2.extend(
                    {
                        url: item.src,
                        success: function (data, textStatus, jqXHR) {
                            var temp = { data, xhr: jqXHR };
                            _mfpTrigger("ParseAjax", temp),
                                mfp.appendContent($2(temp.data), AJAX_NS),
                                (item.finished = !0),
                                _removeAjaxCursor(),
                                mfp._setFocus(),
                                setTimeout(function () {
                                    mfp.wrap.addClass(READY_CLASS);
                                }, 16),
                                mfp.updateStatus("ready"),
                                _mfpTrigger("AjaxContentAdded");
                        },
                        error: function () {
                            _removeAjaxCursor(),
                                (item.finished = item.loadError = !0),
                                mfp.updateStatus("error", mfp.st.ajax.tError.replace("%url%", item.src));
                        },
                    },
                    mfp.st.ajax.settings
                );
                return (mfp.req = $2.ajax(opts)), "";
            },
        },
    });
    var _imgInterval,
        _getTitle = function (item) {
            if (item.data && item.data.title !== void 0) return item.data.title;
            var src = mfp.st.image.titleSrc;
            if (src) {
                if ($2.isFunction(src)) return src.call(mfp, item);
                if (item.el) return item.el.attr(src) || "";
            }
            return "";
        };
    $2.magnificPopup.registerModule("image", {
        options: {
            markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.',
        },
        proto: {
            initImage: function () {
                var imgSt = mfp.st.image,
                    ns = ".image";
                mfp.types.push("image"),
                    _mfpOn(OPEN_EVENT + ns, function () {
                        mfp.currItem.type === "image" && imgSt.cursor && $2(document.body).addClass(imgSt.cursor);
                    }),
                    _mfpOn(CLOSE_EVENT + ns, function () {
                        imgSt.cursor && $2(document.body).removeClass(imgSt.cursor), _window.off("resize" + EVENT_NS);
                    }),
                    _mfpOn("Resize" + ns, mfp.resizeImage),
                    mfp.isLowIE && _mfpOn("AfterChange", mfp.resizeImage);
            },
            resizeImage: function () {
                var item = mfp.currItem;
                if (!(!item || !item.img) && mfp.st.image.verticalFit) {
                    var decr = 0;
                    mfp.isLowIE &&
                        (decr =
                            parseInt(item.img.css("padding-top"), 10) + parseInt(item.img.css("padding-bottom"), 10)),
                        item.img.css("max-height", mfp.wH - decr);
                }
            },
            _onImageHasSize: function (item) {
                item.img &&
                    ((item.hasSize = !0),
                    _imgInterval && clearInterval(_imgInterval),
                    (item.isCheckingImgSize = !1),
                    _mfpTrigger("ImageHasSize", item),
                    item.imgHidden && (mfp.content && mfp.content.removeClass("mfp-loading"), (item.imgHidden = !1)));
            },
            findImageSize: function (item) {
                var counter = 0,
                    img = item.img[0],
                    mfpSetInterval = function (delay) {
                        _imgInterval && clearInterval(_imgInterval),
                            (_imgInterval = setInterval(function () {
                                if (img.naturalWidth > 0) {
                                    mfp._onImageHasSize(item);
                                    return;
                                }
                                counter > 200 && clearInterval(_imgInterval),
                                    counter++,
                                    counter === 3
                                        ? mfpSetInterval(10)
                                        : counter === 40
                                          ? mfpSetInterval(50)
                                          : counter === 100 && mfpSetInterval(500);
                            }, delay));
                    };
                mfpSetInterval(1);
            },
            getImage: function (item, template) {
                var guard = 0,
                    onLoadComplete = function () {
                        item &&
                            (item.img[0].complete
                                ? (item.img.off(".mfploader"),
                                  item === mfp.currItem && (mfp._onImageHasSize(item), mfp.updateStatus("ready")),
                                  (item.hasSize = !0),
                                  (item.loaded = !0),
                                  _mfpTrigger("ImageLoadComplete"))
                                : (guard++, guard < 200 ? setTimeout(onLoadComplete, 100) : onLoadError()));
                    },
                    onLoadError = function () {
                        item &&
                            (item.img.off(".mfploader"),
                            item === mfp.currItem &&
                                (mfp._onImageHasSize(item),
                                mfp.updateStatus("error", imgSt.tError.replace("%url%", item.src))),
                            (item.hasSize = !0),
                            (item.loaded = !0),
                            (item.loadError = !0));
                    },
                    imgSt = mfp.st.image,
                    el = template.find(".mfp-img");
                if (el.length) {
                    var img = document.createElement("img");
                    (img.className = "mfp-img"),
                        item.el && item.el.find("img").length && (img.alt = item.el.find("img").attr("alt")),
                        (item.img = $2(img).on("load.mfploader", onLoadComplete).on("error.mfploader", onLoadError)),
                        (img.src = item.src),
                        el.is("img") && (item.img = item.img.clone()),
                        (img = item.img[0]),
                        img.naturalWidth > 0 ? (item.hasSize = !0) : img.width || (item.hasSize = !1);
                }
                return (
                    mfp._parseMarkup(template, { title: _getTitle(item), img_replaceWith: item.img }, item),
                    mfp.resizeImage(),
                    item.hasSize
                        ? (_imgInterval && clearInterval(_imgInterval),
                          item.loadError
                              ? (template.addClass("mfp-loading"),
                                mfp.updateStatus("error", imgSt.tError.replace("%url%", item.src)))
                              : (template.removeClass("mfp-loading"), mfp.updateStatus("ready")),
                          template)
                        : (mfp.updateStatus("loading"),
                          (item.loading = !0),
                          item.hasSize ||
                              ((item.imgHidden = !0), template.addClass("mfp-loading"), mfp.findImageSize(item)),
                          template)
                );
            },
        },
    });
    var hasMozTransform,
        getHasMozTransform = function () {
            return (
                hasMozTransform === void 0 &&
                    (hasMozTransform = document.createElement("p").style.MozTransform !== void 0),
                hasMozTransform
            );
        };
    $2.magnificPopup.registerModule("zoom", {
        options: {
            enabled: !1,
            easing: "ease-in-out",
            duration: 300,
            opener: function (element) {
                return element.is("img") ? element : element.find("img");
            },
        },
        proto: {
            initZoom: function () {
                var zoomSt = mfp.st.zoom,
                    ns = ".zoom",
                    image;
                if (!(!zoomSt.enabled || !mfp.supportsTransition)) {
                    var duration = zoomSt.duration,
                        getElToAnimate = function (image2) {
                            var newImg = image2
                                    .clone()
                                    .removeAttr("style")
                                    .removeAttr("class")
                                    .addClass("mfp-animated-image"),
                                transition = "all " + zoomSt.duration / 1e3 + "s " + zoomSt.easing,
                                cssObj = {
                                    position: "fixed",
                                    zIndex: 9999,
                                    left: 0,
                                    top: 0,
                                    "-webkit-backface-visibility": "hidden",
                                },
                                t = "transition";
                            return (
                                (cssObj["-webkit-" + t] =
                                    cssObj["-moz-" + t] =
                                    cssObj["-o-" + t] =
                                    cssObj[t] =
                                        transition),
                                newImg.css(cssObj),
                                newImg
                            );
                        },
                        showMainContent = function () {
                            mfp.content.css("visibility", "visible");
                        },
                        openTimeout,
                        animatedImg;
                    _mfpOn("BuildControls" + ns, function () {
                        if (mfp._allowZoom()) {
                            if (
                                (clearTimeout(openTimeout),
                                mfp.content.css("visibility", "hidden"),
                                (image = mfp._getItemToZoom()),
                                !image)
                            ) {
                                showMainContent();
                                return;
                            }
                            (animatedImg = getElToAnimate(image)),
                                animatedImg.css(mfp._getOffset()),
                                mfp.wrap.append(animatedImg),
                                (openTimeout = setTimeout(function () {
                                    animatedImg.css(mfp._getOffset(!0)),
                                        (openTimeout = setTimeout(function () {
                                            showMainContent(),
                                                setTimeout(function () {
                                                    animatedImg.remove(),
                                                        (image = animatedImg = null),
                                                        _mfpTrigger("ZoomAnimationEnded");
                                                }, 16);
                                        }, duration));
                                }, 16));
                        }
                    }),
                        _mfpOn(BEFORE_CLOSE_EVENT + ns, function () {
                            if (mfp._allowZoom()) {
                                if ((clearTimeout(openTimeout), (mfp.st.removalDelay = duration), !image)) {
                                    if (((image = mfp._getItemToZoom()), !image)) return;
                                    animatedImg = getElToAnimate(image);
                                }
                                animatedImg.css(mfp._getOffset(!0)),
                                    mfp.wrap.append(animatedImg),
                                    mfp.content.css("visibility", "hidden"),
                                    setTimeout(function () {
                                        animatedImg.css(mfp._getOffset());
                                    }, 16);
                            }
                        }),
                        _mfpOn(CLOSE_EVENT + ns, function () {
                            mfp._allowZoom() &&
                                (showMainContent(), animatedImg && animatedImg.remove(), (image = null));
                        });
                }
            },
            _allowZoom: function () {
                return mfp.currItem.type === "image";
            },
            _getItemToZoom: function () {
                return mfp.currItem.hasSize ? mfp.currItem.img : !1;
            },
            _getOffset: function (isLarge) {
                var el;
                isLarge ? (el = mfp.currItem.img) : (el = mfp.st.zoom.opener(mfp.currItem.el || mfp.currItem));
                var offset = el.offset(),
                    paddingTop = parseInt(el.css("padding-top"), 10),
                    paddingBottom = parseInt(el.css("padding-bottom"), 10);
                offset.top -= $2(window).scrollTop() - paddingTop;
                var obj = {
                    width: el.width(),
                    height: (_isJQ ? el.innerHeight() : el[0].offsetHeight) - paddingBottom - paddingTop,
                };
                return (
                    getHasMozTransform()
                        ? (obj["-moz-transform"] = obj.transform =
                              "translate(" + offset.left + "px," + offset.top + "px)")
                        : ((obj.left = offset.left), (obj.top = offset.top)),
                    obj
                );
            },
        },
    });
    var IFRAME_NS = "iframe",
        _emptyPage = "//about:blank",
        _fixIframeBugs = function (isShowing) {
            if (mfp.currTemplate[IFRAME_NS]) {
                var el = mfp.currTemplate[IFRAME_NS].find("iframe");
                el.length &&
                    (isShowing || (el[0].src = _emptyPage),
                    mfp.isIE8 && el.css("display", isShowing ? "block" : "none"));
            }
        };
    $2.magnificPopup.registerModule(IFRAME_NS, {
        options: {
            markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
            srcAction: "iframe_src",
            patterns: {
                youtube: { index: "youtube.com", id: "v=", src: "//www.youtube.com/embed/%id%?autoplay=1" },
                vimeo: { index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1" },
                gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
            },
        },
        proto: {
            initIframe: function () {
                mfp.types.push(IFRAME_NS),
                    _mfpOn("BeforeChange", function (e, prevType, newType) {
                        prevType !== newType &&
                            (prevType === IFRAME_NS ? _fixIframeBugs() : newType === IFRAME_NS && _fixIframeBugs(!0));
                    }),
                    _mfpOn(CLOSE_EVENT + "." + IFRAME_NS, function () {
                        _fixIframeBugs();
                    });
            },
            getIframe: function (item, template) {
                var embedSrc = item.src,
                    iframeSt = mfp.st.iframe;
                $2.each(iframeSt.patterns, function () {
                    if (embedSrc.indexOf(this.index) > -1)
                        return (
                            this.id &&
                                (typeof this.id == "string"
                                    ? (embedSrc = embedSrc.substr(
                                          embedSrc.lastIndexOf(this.id) + this.id.length,
                                          embedSrc.length
                                      ))
                                    : (embedSrc = this.id.call(this, embedSrc))),
                            (embedSrc = this.src.replace("%id%", embedSrc)),
                            !1
                        );
                });
                var dataObj = {};
                return (
                    iframeSt.srcAction && (dataObj[iframeSt.srcAction] = embedSrc),
                    mfp._parseMarkup(template, dataObj, item),
                    mfp.updateStatus("ready"),
                    template
                );
            },
        },
    });
    var _getLoopedId = function (index) {
            var numSlides = mfp.items.length;
            return index > numSlides - 1 ? index - numSlides : index < 0 ? numSlides + index : index;
        },
        _replaceCurrTotal = function (text, curr, total) {
            return text.replace(/%curr%/gi, curr + 1).replace(/%total%/gi, total);
        };
    $2.magnificPopup.registerModule("gallery", {
        options: {
            enabled: !1,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: !0,
            arrows: !0,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%",
        },
        proto: {
            initGallery: function () {
                var gSt = mfp.st.gallery,
                    ns = ".mfp-gallery";
                if (((mfp.direction = !0), !gSt || !gSt.enabled)) return !1;
                (_wrapClasses += " mfp-gallery"),
                    _mfpOn(OPEN_EVENT + ns, function () {
                        gSt.navigateByImgClick &&
                            mfp.wrap.on("click" + ns, ".mfp-img", function () {
                                if (mfp.items.length > 1) return mfp.next(), !1;
                            }),
                            _document.on("keydown" + ns, function (e) {
                                e.keyCode === 37 ? mfp.prev() : e.keyCode === 39 && mfp.next();
                            });
                    }),
                    _mfpOn("UpdateStatus" + ns, function (e, data) {
                        data.text && (data.text = _replaceCurrTotal(data.text, mfp.currItem.index, mfp.items.length));
                    }),
                    _mfpOn(MARKUP_PARSE_EVENT + ns, function (e, element, values, item) {
                        var l = mfp.items.length;
                        values.counter = l > 1 ? _replaceCurrTotal(gSt.tCounter, item.index, l) : "";
                    }),
                    _mfpOn("BuildControls" + ns, function () {
                        if (mfp.items.length > 1 && gSt.arrows && !mfp.arrowLeft) {
                            var markup = gSt.arrowMarkup,
                                arrowLeft = (mfp.arrowLeft = $2(
                                    markup.replace(/%title%/gi, gSt.tPrev).replace(/%dir%/gi, "left")
                                ).addClass(PREVENT_CLOSE_CLASS)),
                                arrowRight = (mfp.arrowRight = $2(
                                    markup.replace(/%title%/gi, gSt.tNext).replace(/%dir%/gi, "right")
                                ).addClass(PREVENT_CLOSE_CLASS));
                            arrowLeft.click(function () {
                                mfp.prev();
                            }),
                                arrowRight.click(function () {
                                    mfp.next();
                                }),
                                mfp.container.append(arrowLeft.add(arrowRight));
                        }
                    }),
                    _mfpOn(CHANGE_EVENT + ns, function () {
                        mfp._preloadTimeout && clearTimeout(mfp._preloadTimeout),
                            (mfp._preloadTimeout = setTimeout(function () {
                                mfp.preloadNearbyImages(), (mfp._preloadTimeout = null);
                            }, 16));
                    }),
                    _mfpOn(CLOSE_EVENT + ns, function () {
                        _document.off(ns), mfp.wrap.off("click" + ns), (mfp.arrowRight = mfp.arrowLeft = null);
                    });
            },
            next: function () {
                (mfp.direction = !0), (mfp.index = _getLoopedId(mfp.index + 1)), mfp.updateItemHTML();
            },
            prev: function () {
                (mfp.direction = !1), (mfp.index = _getLoopedId(mfp.index - 1)), mfp.updateItemHTML();
            },
            goTo: function (newIndex) {
                (mfp.direction = newIndex >= mfp.index), (mfp.index = newIndex), mfp.updateItemHTML();
            },
            preloadNearbyImages: function () {
                var p = mfp.st.gallery.preload,
                    preloadBefore = Math.min(p[0], mfp.items.length),
                    preloadAfter = Math.min(p[1], mfp.items.length),
                    i;
                for (i = 1; i <= (mfp.direction ? preloadAfter : preloadBefore); i++) mfp._preloadItem(mfp.index + i);
                for (i = 1; i <= (mfp.direction ? preloadBefore : preloadAfter); i++) mfp._preloadItem(mfp.index - i);
            },
            _preloadItem: function (index) {
                if (((index = _getLoopedId(index)), !mfp.items[index].preloaded)) {
                    var item = mfp.items[index];
                    item.parsed || (item = mfp.parseEl(index)),
                        _mfpTrigger("LazyLoad", item),
                        item.type === "image" &&
                            (item.img = $2('<img class="mfp-img" />')
                                .on("load.mfploader", function () {
                                    item.hasSize = !0;
                                })
                                .on("error.mfploader", function () {
                                    (item.hasSize = !0), (item.loadError = !0), _mfpTrigger("LazyLoadError", item);
                                })
                                .attr("src", item.src)),
                        (item.preloaded = !0);
                }
            },
        },
    });
    var RETINA_NS = "retina";
    $2.magnificPopup.registerModule(RETINA_NS, {
        options: {
            replaceSrc: function (item) {
                return item.src.replace(/\.\w+$/, function (m) {
                    return "@2x" + m;
                });
            },
            ratio: 1,
        },
        proto: {
            initRetina: function () {
                if (window.devicePixelRatio > 1) {
                    var st = mfp.st.retina,
                        ratio = st.ratio;
                    (ratio = isNaN(ratio) ? ratio() : ratio),
                        ratio > 1 &&
                            (_mfpOn("ImageHasSize." + RETINA_NS, function (e, item) {
                                item.img.css({ "max-width": item.img[0].naturalWidth / ratio, width: "100%" });
                            }),
                            _mfpOn("ElementParse." + RETINA_NS, function (e, item) {
                                item.src = st.replaceSrc(item, ratio);
                            }));
                }
            },
        },
    }),
        _checkInstance();
}),
    $(function () {
        $(".notify-link").magnificPopup({
            type: "inline",
            preloader: !1,
            midClick: !0,
            fixedContentPos: !0,
            modal: !0,
        }),
            $(document).on("click", ".popup-modal-dismiss", function (e) {
                e.preventDefault(), $.magnificPopup.close();
            });
    }),
    $("#notifypop").on("click", ".notpopupbutton", function () {
        alert('hi');
        var em = $(".notemail").val(),
            lnam = $(".notname").val(),
            phno = $(".phonno").val(),
            test1 = $("#test1").val(),
            test2 = $("#test2").val();
        console.log(phno);
        var vari = $(".notvariant").val();
        const options = {
            method: "POST",
            headers: { "Content-Type": "application/json", revision: "2024-06-15" },
            body: JSON.stringify({
                data: {
                    type: "back-in-stock-subscription",
                    attributes: {
                        channels: ["EMAIL"],
                        profile: { data: { type: "profile", attributes: { email: em } } },
                    },
                    relationships: {
                        variant: { data: { type: "catalog-variant", id: "$shopify:::$default:::" + vari } },
                    },
                },
            }),
        };
        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WenqMj", options)
            .then((response) => console.log(response))
            .catch((err) => console.error(err)),
            $(".hideit").hide(),
            $(".showit").show();
    });
//# sourceMappingURL=/cdn/shop/t/181/assets/jquery.magnific-popup.js.map?v=46420191674382172451775208780
